import { protectedGet } from "./../restUtil";

const ALL_ROLES = "allRoles";

export function deleteRoles() {
  localStorage.removeItem(ALL_ROLES);
}

export function getAllRoles(args, onSuccess, onError) {
  if (localStorage && localStorage.getItem(ALL_ROLES)) {
    return onSuccess(JSON.parse(localStorage.getItem(ALL_ROLES)));
  }
  return protectedGet(
    "/admin/roles",
    null,
    function (resp) {
      if (resp && resp.list) {
        // since roles list is not changed very often we're saving it in global variable
        localStorage && localStorage.setItem(ALL_ROLES, JSON.stringify(resp.list));
        return onSuccess(resp.list);
      } else {
        return onError && onError({ errors: "invalid response structure" });
      }
    },
    onError
  );
}
